/* eslint-disable no-console */
import {Flex, Avatar as AvatarAnt, Skeleton} from 'antd';
import React, {useEffect, useRef} from 'react';

import useUserStore from '../../store/userStore/userStore';

const ShowChat: React.FC<{
  allChat: any;
  isChatLoading: boolean;
}> = ({allChat, isChatLoading}) => {
  const userDetails = useUserStore.getState().userDetails;
  const chatLoadRef = useRef<any>(null);
  const chatRef = useRef<any[]>([]);

  useEffect(() => {
    if (isChatLoading) {
      chatLoadRef?.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start' // Scroll to the top of the button
      });
    } else {
      chatRef?.current?.[allChat?.length - 1].scrollIntoView({
        behavior: 'smooth',
        block: 'start' // Scroll to the top of the button
      });
    }
  }, [isChatLoading]);

  return (
    <Flex
      style={{
        padding: '3rem',
        height: 'fit-content',
        display: 'flex',
        flexDirection: 'column',
        overflowX: 'scroll',
        overflow: 'hidden',
        width: '100%'
      }}
      gap={10}
    >
      {allChat?.map((item: any, index: number) => {
        return (
          <Flex
            align="center"
            key={index}
            justify={item.type === 'send' ? 'end' : 'start'}
            ref={(ref: any) => (chatRef.current[index] = ref)}
            style={
              item.type === 'send'
                ? {marginLeft: '20px'}
                : item.type === 'error'
                  ? {marginRight: '20px', color: '#FF474D'}
                  : {marginRight: '20px'}
            }
          >
            {/* <Flex align="center"></Flex> */}
            {item.type === 'send' ? (
              <Flex
                style={{
                  borderRadius: '8px',
                  backgroundColor: '#F3F4F8',
                  padding: '12px',
                  flex: 15,
                  maxWidth: '100%',
                  wordBreak: 'break-all',
                  whiteSpace: 'pre-wrap'
                }}
              >
                {item?.value}
              </Flex>
            ) : (
              <div
                style={{
                  borderRadius: '8px',
                  backgroundColor: '#F3F4F8',
                  padding: '12px',
                  flex: 15,
                  maxWidth: '100%',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'keep-all',
                  overflowWrap: 'break-word'
                }}
              >
                {item?.value}
              </div>
            )}
            {item.type === 'send' && (
              <AvatarAnt
                className="userAvatar"
                style={{
                  backgroundColor: '#404252',
                  color: '#fff',
                  fontSize: 20,
                  margin: '1px 0px 0px 5px',
                  alignItems: 'center',
                  alignSelf: 'flex-start'
                }}
              >
                {`${userDetails?.firstName?.[0] ?? ''}`}
              </AvatarAnt>
            )}
          </Flex>
        );
      })}
      {isChatLoading && (
        <div ref={(ref) => (chatLoadRef.current = ref)} style={{width: '100%'}}>
          <Skeleton active style={{width: '100%'}} />
        </div>
      )}
    </Flex>
  );
};

export default ShowChat;
